<template>
  <Adsense
    :data-ad-slot="dataAdSlot"
    style="display:inline-block;width:728px;height:90px"
    data-ad-format="horizontal"
  ></Adsense>
</template>

<script>
import Adsense from './Adsense'

export default {
  components: {
    Adsense
  },

  props: {
    dataAdSlot: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdsenseHorizontal.vue